/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const TestWrapper = styled.div`
  background: #f6f7fb !important;
  &.lrn-assess {
    margin: 0;
    .lrn-group-top {
      padding-inline: 16px;
    }
    .items .progress span {
      background: #4786fc !important;
    }

    .lrn-group-bottom {
      position: sticky;
      bottom: 0;
      z-index: 1000;
      background-color: #fff;
      border-radius: 0.5rem;
    }
    .lrn-top-left-region .test_title_element .test-title-text {
      margin-inline-start: 0.25rem !important;
      font-size: 1.5rem !important;
      color: #9e6500 !important;
      font-weight: 500 !important;
      font-family: 'roboto', sans-serif !important;
    }
    .lrn-bottom-region {
      display: flex;
      justify-content: center;
      .bottom-wrapper {
        /* Shared base styles */
        button[data-original-title] {
          border: none;
          border-radius: 8px;
          padding: 0.5rem 1rem;
          font-weight: 600;
          cursor: pointer;
          transition: background-color 0.2s ease, opacity 0.2s ease;
        }
        /* Back button */
        button[data-original-title='Back'] {
          background-color: #f0f0f0;
          color: #333;
        }
        button[data-original-title='Back']:hover:not(:disabled) {
          background-color: #e0e0e0;
        }
        /* Finish button */
        button[data-original-title='Finish'] {
          background-color: #4786fc;
          color: #fff;
        }
        button[data-original-title='Finish']:hover:not(:disabled) {
          background-color: #035dbe;
        }
        /* Review button */
        button[data-original-title='Review'] {
          background-color: #4786fc;
          color: #000;
        }
        button[data-original-title='Review']:hover:not(:disabled) {
          background-color: #035dbe;
        }
        /* Next button */
        button[data-original-title='Next'] {
          background-color: #1e7d55;
          color: #fff;
        }
        button[data-original-title='Next']:hover:not(:disabled) {
          background-color: #4ddfa7;
        }
        /* Disabled state */
        button:disabled {
          cursor: not-allowed;
          opacity: 0.5;
          background-color: #f0f0f0 !important;
          color: #999 !important;
        }
      }
    }
    .lrn-horizontal-toc .pagination .lrn-assess-btn,
    .lrn-horizontal-toc .lrn-assess-pagination .lrn-assess-btn {
      border: solid 1px #4786fc !important;
      color: #4786fc !important;
      border-radius: 8px !important;
      font-weight: 600 !important;
      cursor: pointer;
      transition: background-color 0.2s ease, opacity 0.2s ease;
      :hover:not(:disabled) {
        background-color: #e5e5e5 !important;
      }
      :disabled {
        cursor: not-allowed;
        opacity: 0.5;
        background-color: #f0f0f0 !important;
        color: #999 !important;
      }
    }

    .lrn-horizontal-toc
      li[data-attempted='partially_attempted']
      .lrn-assess-btn.lrn-assess-horizontal-link,
    .lrn-horizontal-toc
      li[data-attempted='fully_attempted']
      .lrn-assess-btn.lrn-assess-horizontal-link {
      background: #fff !important;
      border: solid 2px #9e6500 !important;
      color: #9e6500 !important;
      border-radius: 8px !important;
      font-weight: 600 !important;
      cursor: pointer;
      &:before {
        display: none !important;
      }
    }
    .toc .lrn-pager li.pagination-active a {
      background: #4786fc !important;
      color: #fff !important;
      border-radius: 8px !important;
      border: solid 1px #4786fc !important;
    }
    .lrn-horizontal-toc
      .lrn-assess-pagination
      li[data-attempted='fully_attempted']:not(.pagination-active):before {
      display: none !important;
    }
    .lrn-horizontal-toc
      .lrn-assess-pagination
      li[data-attempted='fully_attempted'].pagination-active {
      & a {
        background-color: #2E5BC7 !important;
        color: #fff !important;
      }
    }

    .lrn-horizontal-toc .pagination .pagination-active,
    .lrn-horizontal-toc .lrn-assess-pagination .pagination-active {
      background-color: transparent !important;
      &:before {
        display: none !important;
      }
      &:after {
        display: none !important;
      }
    }
    .item-count {
      font-weight: bold;
      font-size: 1.25rem;
      color: #9e6500;
    }
    .lrn-top-left-region {
      display: flex;
      align-items: center;
    }
    .lrn-top-right-region {
      width: 50%;
    }
  }
  /* Common Rules */
  .lrn {
    font-family: 'roboto', sans-serif !important;
    color: #010101 !important;
    background: inherit;
  }
  /* .lrn-assess .learnosity-item .lrn-assess-content.content */
  .lrn-assess-content {
    &.content {
      padding-inline: 0.4rem;
      @media (min-width: 768px) {
        padding-inline: 0.5rem;
      }
    }
    p {
      font-weight: normal;
    }
    .row {
      margin: 0px;
      padding: 0;
      display: flex;
      justify-content: space-between;
      align-items: stretch;
      flex-wrap: wrap;
      .lrn-viewport {
        height: 100% !important;
      }
      > [class^='col-'] {
        padding-inline: 0.5rem;
      }
      :before {
        display: none;
      }
      :after {
        display: none;
      }
    }
    .lrn_mcq.lrn_widget {
      .lrn_response {
        .lrn_mcqgroup-block {
          input:focus + label {
            outline: none !important;
            box-shadow: none !important;
          }
        }
      }
      .lrn_mcqgroup {
        .lrn-mcq-option {
          border: solid 1px #cccccc;
          .lrn-possible-answer {
            display: flex;
            align-items: start;
            justify-content: start;
            gap: 0.5rem;
          }
          .lrn_choiceLabel {
            width: 1.5rem !important;
            height: 1.5rem !important;
            min-width: 1.5rem !important;
            min-height: 1.5rem !important;
            border-radius: 50%;
            border: solid 2px #4885fb;
            background-color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
          &.lrn_selected {
            .lrn_choiceLabel {
              background-color: #4786fc !important;
              color: white !important;
              border: solid 1px #4786fc !important;
            }
          }
        }
      }
    }
    .lrn_feature .lrn-feature-heading {
      font-weight: 600 !important;
    }
  }

  & p {
    font-size: 1rem !important;
    line-height: 1.625rem !important;
  }
  .lrn_question {
    font-size: 1.3em;
    font-weight: bold;
    font-family: 'roboto', sans-serif !important;
  }
  .lrn_response_input.lrn_incorrect:after,
  .lrn_response_container.lrn_correct:after,
  .lrn_response_container.lrn_incorrect:after,
  .lrn_response_input_wrapper.lrn_incorrect:after,
  .lrn_response_input_wrapper.lrn_correct:after,
  .lrn_mcq .lrn_mcqgroup.lrn_correct:after,
  .lrn_mcq .lrn_mcqgroup.lrn_incorrect:after,
  .lrn-response-validate-wrapper.lrn_correct:after,
  .lrn-response-validate-wrapper.lrn_incorrect:after {
    height: 2em !important;
    line-height: 2em !important;
    width: 2em !important;
    border-radius: 1.5em !important;
    margin-top: -0.3em;
  }
  /* Cloze Text */
  .lrn_clozetext .lrn_textinput:after {
    content: none !important;
    display: none !important;
  }
  .lrn_clozetext .lrn_textinput.lrn_correct input {
    border-style: solid !important;
    border-width: 0.1em 0.1em 0.1em 0.3em !important;
    border-color: #4a700a !important;
    background-color: transparent !important;
  }
  .lrn_clozetext .lrn_textinput.lrn_incorrect input,
  .lrn_clozetext .lrn_textinput.lrn_not_attempted input {
    border-style: solid !important;
    border-width: 0.1em 0.1em 0.1em 0.3em !important;
    border-color: #dd002f !important;
    background-color: transparent !important;
  }
  /* Cloze Association */
  .lrn_association .lrn_possibilityList .lrn_btn_drag .lrn_icon:before,
  .lrn_clozeassociation .lrn_possibilityList .lrn_btn_drag .lrn_icon:before,
  .lrn_imageclozeassociationV2 .lrn_possibilityList .lrn_btn_drag:before,
  .lrn_orderlist .lrn_item:before {
    content: '⠿' !important;
    top: 0 !important;
    font-size: 1.1em;
    color: #7a8599;
  }
  .lrn_sort_block .lrn_item > div {
    display: inline-block !important;
  }
  .lrn .lrn_possibilityListContainer.lrn_list_bottom:before,
  .lrn_clozeassociation span.lrn_correct:after,
  .lrn_clozeassociation span.lrn_incorrect:after,
  .lrn_tokenhighlight .lrn_tokenhighlight_highlight:after {
    content: none !important;
    display: none !important;
  }
  .lrn_clozeassociation .lrn_dropzone,
  .lrn_imageclozeassociationV2 .lrn_dropzone_mask {
    border-radius: 0.4em !important;
  }
  /* Image Cloze Text and Image Cloze Dropdown */
  .lrn_clozeassociation .lrn_incorrect .lrn_not_attempted_marker,
  .lrn_clozeassociation .lrn_correct .lrn_not_attempted_marker,
  .lrn_imageclozetext .lrn_textinput.lrn_not_attempted input,
  .lrn_imageclozedropdown .lrn_combobox span {
    background-color: #fbe3e3 !important;
  }
  .lrn_imageclozetext .lrn_cloze_response,
  .lrn_imageclozedropdown .lrn_combobox span {
    border: 1px solid #e5e5e5 !important;
    padding-left: 1em !important;
  }
  .lrn_imageclozetext .lrn_not_attempted:after,
  .lrn_imageclozedropdown .lrn_not_attempted:after {
    content: '' !important;
    color: #dd002f !important;
    position: absolute !important;
    top: 20% !important;
    right: 0.4em !important;
    font-family: LearnosityIconsRegular !important;
  }
  .lrn_imageclozedropdown .lrn_not_attempted:after {
    top: 5% !important;
  }
  .lrn-cloze-select::-webkit-scrollbar {
    width: 0.5em;
  }
  .lrn-cloze-select::-webkit-scrollbar-track {
    box-shadow: inset 0 0 2px grey;
    border-radius: 5px;
    background: #e5e5e5;
  }
  .lrn-cloze-select::-webkit-scrollbar-thumb {
    background: #ff9e16;
    border-radius: 5px;
  }
  .lrn_imageclozeassociationV2 .lrn_possibilityListContainer.lrn_list_bottom:before {
    content: none !important;
  }
  .lrn .lrn_possibilityList,
  .lrn .lrn_possibilityListContainer {
    background-color: transparent !important;
  }
  /* Check Button */
  button.lrn_validate {
    background-color: #2e7d32 !important;
    color: #fff !important;
    border-radius: 0.4em !important;
    padding: 0.2em 1.5em !important;
  }
  /* Text token highlight */
  .lrn_tokenhighlight .lrn_tokenhighlight_highlight {
    background-color: #fff8df !important;
  }
  .lrn_tokenhighlight .lrn_tokenhighlight_text .lrn_token.lrn_incorrect {
    background-color: #fbe3e3 !important;
    border-color: #dd002f !important;
  }
  .lrn_tokenhighlight .lrn_tokenhighlight_text .lrn_token.lrn_correct {
    background-color: #f0f8ed !important;
    border-color: #4a700a !important;
  }
  /* Text token highlight */
  .lrn_orderlist .lrn_sort_gripper {
    display: none !important;
  }
  .lrn_orderlist .lrn_item:before {
    margin-right: 1em;
  }
  .lrn_orderlist .lrn_sort_block {
    margin-bottom: 0 !important;
  }
  .lrn_association .lrn_assoc_question {
    border-radius: 0.4em;
  }
  .lrn_association .lrn_response .lrn_arrows .lrn_arrow {
    border-bottom: 0.2em solid #7a8599 !important;
  }
  .lrn_association .lrn_response .lrn_arrows .lrn_arrow:before,
  .lrn_association .lrn_response .lrn_arrows .lrn_arrow:after {
    top: -0.25em !important;
    border: 0.4em solid #7a8599 !important;
  }
  .lrn_association .lrn_dropzone {
    border-radius: 0.4em !important;
  }
  .lrn_association .lrn_dragdrop:not(.lrn_disabled).lrn_dropzone.lrn_highlight {
    border: 1px solid #ff9e16 !important;
    border-radius: 0.4em !important;
  }
  /* Multiple Choice Question */
  .lrn_mcq .lrn_response .lrn_mcqgroup-block .lrn-mcq-option.lrn_incorrect .lrn-label,
  .lrn_mcq .lrn_response .lrn_mcqgroup-block .lrn-mcq-option.lrn_correct .lrn-label {
    background-color: #fcfcd3 !important;
  }
  .lrn_mcq .lrn-mcq-option.lrn_selected {
    border-color: transparent !important;
  }
  .lrn_mcq .lrn_mcqgroup-block .lrn-mcq-option.lrn_incorrect,
  .lrn_mcq .lrn_mcqgroup-block .lrn-mcq-option.lrn_correct {
    border-style: solid !important;
    border-width: 0.1em 0.1em 0.1em 0.3em !important;
    background-color: transparent !important;
  }
  .lrn_mcq .lrn_mcqgroup-block .lrn-mcq-option.lrn_incorrect {
    border-color: #dd002f !important;
  }
  .lrn_mcq .lrn_mcqgroup-block .lrn-mcq-option.lrn_correct {
    border-color: #4a700a !important;
  }
  .lrn_mcq .lrn-response-validate-wrapper {
    border-style: solid !important;
    border-width: 0.1em 0.1em 0.1em 0.3em !important;
    background-color: transparent !important;
  }
  .lrn_mcq .lrn_mcqgroup.lrn_mcqgroup-vertical .lrn-mcq-option {
    border: none !important;
  }
  .lrn_mcq .lrn_mcqgroup.lrn_mcqgroup-vertical .lrn-mcq-option.lrn_correct,
  .lrn_mcq .lrn_mcqgroup.lrn_mcqgroup-vertical .lrn-mcq-option.lrn_incorrect {
    background-color: #fff8df !important;
  }
  .lrn_imagecloze_container {
    min-height: 80px;
  }
  .lrn_distractor_rationale_content {
    margin: 1.42857em !important;
  }
  .lrn_validation_stem_numeration {
    display: none;
  }

  .lrn_scrollablepassage {
    .lrn-viewport {
      height: 100% !important;
      overflow: auto !important;
      background: white;
      border: 1px solid #ccc;
      border-radius: 8px;
    }
    .lds-root {
      padding: 1rem;
      background: white !important;
    }
  }

  .lrn_widget.lrn_mcq .lrn_mcqgroup.lrn_mcqgroup-horizontal .lrn-label,
  .lrn_widget.lrn_mcq .lrn_mcqgroup.lrn_mcqgroup-vertical .lrn-label {
    border: solid 1px #cccccc;
    border-radius: 8px;
    /* background: #cccccc4a; */
  }
  .lrn_widget .lrn_selected {
    border: solid 1px #4786fc !important;
    color: #fff !important;
    border-radius: 8px;
    border: solid 1px #4786fc !important;
  }
  .lrn_widget.lrn_mcq .lrn_mcqgroup {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .lrn_widget input[type='radio'] {
    /* Increase size */
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: #4786fc !important; /* modern way to change selected color */
  }

  /* For browsers that don't fully support accent-color, use fallback */
  .lrn_widget input[type='radio']:checked {
    /* fallback if accent-color not supported */
    filter: drop-shadow(0 0 0 #4786fc);
  }
  .lrn_widget.lrn_mcq .lrn_response .lrn_mcqgroup-block .lrn-mcq-option .lrn-label {
    background-color: white !important;
  }
  .lrn_widget.lrn_mcq .lrn_response .lrn_mcqgroup-block .lrn-input[type='radio'] {
    &:focus {
      outline: none !important;
      box-shadow: none !important;
      border: none !important;
    }
  }
  .lrn_widget.lrn_mcq .lrn_response .lrn_mcqgroup-block .lrn-mcq-option {
    padding: 0.5rem 1rem !important;
    border-radius: 8px !important;
    border: solid 1px #cccccc !important;
    box-shadow: none !important;
  }

  /* Adaptive ItemBranching specific styles */
  .lrn-assess-content > .row > div {
    background-color: white !important;
    padding: 1rem;
    border-radius: 8px;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
    margin-bottom: 1rem;
    font-family: 'roboto', sans-serif !important;
    color: #010101 !important;
    background: inherit;

    & p {
      font-size: 1rem !important;
      line-height: 1.625rem !important;
    }
    .lrn_question,
    .lrn_sharedpassage {
      font-size: 1.3em;
      font-family: 'roboto', sans-serif !important;
    }
    .lrn_sharedpassage {
      font-weight: normal !important;
    }
    .lrn_selected {
      color: inherit !important;
    }
  }
  /* A11y: Learnosity fullscreen dialog buttons — override insufficient contrast */
  button[name='enter_full_screen'] {
    background-color: #1565C0 !important;
    color: #fff !important;
  }
  button[name='resume_without_full_screen'] {
    color: #333333 !important;
  }
`;
